export const zhCN = {
  productName: "Fastboot.js Next",
  tagline: "浏览器里的 Android Fastboot 工具台",
  navWorkspace: "工作台",
  navSafety: "安全",
  navDeploy: "部署",
  heroTitle: "Modern Web Fastboot Toolkit",
  heroSubtitle: "基于 WebUSB 的浏览器端 Fastboot 工具，重做为 Material Design 3 风格的公开发布网站。",
  connect: "连接设备",
  disconnect: "断开连接",
  github: "GitHub",
  safetyTitle: "高风险操作提示",
  safetyText: "刷机、解锁或写入分区可能导致数据丢失、设备无法启动、保修受影响。请先备份数据，确认镜像来源可信，并且不要在不理解后果时执行危险命令。",
  browserNotice: "WebUSB 主要支持 Chromium 系浏览器。请将设备启动到 bootloader / fastboot 模式。",
  device: "设备",
  notConnected: "未连接",
  connecting: "正在连接",
  connected: "已连接",
  running: "执行中",
  success: "完成",
  error: "错误",
  serial: "序列号",
  product: "产品",
  variant: "型号变体",
  bootloader: "Bootloader",
  secure: "Secure",
  unlocked: "Unlocked",
  currentSlot: "当前 Slot",
  battery: "电量 / 电压",
  maxDownload: "最大下载大小",
  unknown: "未知",
  tasks: "任务",
  commandTab: "命令",
  bootTab: "Boot 镜像",
  flashTab: "Flash 分区",
  zipTab: "Flash ZIP",
  commandLabel: "Fastboot 命令",
  commandPlaceholder: "getvar:all",
  runCommand: "执行命令",
  selectBootImage: "选择 boot.img",
  bootImage: "执行 boot",
  partitionLabel: "分区名",
  partitionPlaceholder: "boot",
  selectImage: "选择 image",
  flashPartition: "Flash 分区",
  selectZip: "选择 factory image / update.zip",
  flashZip: "Flash ZIP",
  confirmDanger: "此操作可能修改设备启动状态或写入分区。确认继续？",
  progress: "进度",
  idleProgress: "等待任务",
  logs: "日志",
  clearLogs: "清空",
  copyLogs: "复制",
  copied: "日志已复制",
  deployTitle: "静态部署",
  deployText: "构建产物是纯静态资源，可部署到 GitHub Pages 或 Cloudflare Pages。GitHub Pages 使用 /Fastboot.js-Next/ base 路径，Cloudflare Pages 可设置 VITE_BASE_PATH=/。",
  themeLight: "浅色",
  themeDark: "深色",
  themeSystem: "跟随系统",
  language: "语言",
  theme: "主题",
  webusbUnavailable: "当前浏览器不支持 WebUSB。",
  mockMode: "未连接真实设备：适配层已保留 android-fastboot 接入路径。",
  reconnectNeeded: "设备重启后需要重新授权 USB 连接。",
  noFile: "请先选择文件。",
  noPartition: "请输入分区名。",
  emptyCommand: "请输入 fastboot 命令。",
  buildFor: "支持 GitHub Pages / Cloudflare Pages",
  relationship: "基于 kdrag0n/fastboot.js 的 WebUSB 能力与 demo API 设计。"
} as const;
